import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_NAME } from '../../config';
import { AlertContext } from '../../alerts/AlertContext';
import { AuthContext } from '../../auth/AuthContext';
import { getRoleHomePath } from '../../auth/role-home';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import EnvironmentBadge from './EnvironmentBadge';
import ConnectionHealthPill from './ConnectionHealthPill';
import HeaderUserMenu from './HeaderUserMenu';

function Header({ onToggleSidebar }) {
  const { t } = useTranslation(['ui']);
  const { unreadCount, openAlertsModal } = useContext(AlertContext);
  const { role } = useContext(AuthContext);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center gap-3">
          <div className="flex items-center gap-3">
            <button
              type="button"
              className="block md:hidden mr-1 text-secondary-600 hover:text-secondary-900 focus:outline-none"
              onClick={onToggleSidebar}
              aria-label={t('ui:header.menu')}
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <Link to={getRoleHomePath(role)} className="flex items-center gap-2">
              <span className="text-xl font-bold text-primary-600">{APP_NAME}</span>
            </Link>
            <EnvironmentBadge />
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden sm:block">
              <ConnectionHealthPill />
            </div>
            <LanguageSwitcher />
            <button
              type="button"
              onClick={openAlertsModal}
              className="relative bg-primary-100 p-1.5 rounded-full text-primary-600 hover:text-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              aria-label={t('ui:header.notifications')}
            >
              {unreadCount > 0 && (
                <span className="badge-count">{unreadCount}</span>
              )}
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button>
            <HeaderUserMenu />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
